import type { DeleteNoveltyPricesOperationRequest } from '@/api';
import { getApiClient } from '@/api/client';
import { useMutation } from '@tanstack/react-query';

export const useResetNoveltyPrices = () => {
  return useMutation({
    mutationFn: (request: DeleteNoveltyPricesOperationRequest) =>
      getApiClient().deleteNoveltyPrices(request),
  });
};
